export const Variables = {
  scrollHeight: 200,
};
